/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-23 10:35:38
 *
 * LastModified: 2017-05-23 10:35:38
 *-------------------------------------------------------*/

const initState = { sending: false }
const requestStatus = (state = initState, action) => {
  switch (action.type) {
    case 'START_REQUEST':
      return { sending: true }
    case 'STOP_REQUEST':
      return initState
    case 'REQUEST_ERROR':
      return { sending: false, error: action.payload }
    default:
      return state
  }
}

module.exports = requestStatus



// WEBPACK FOOTER //
// ./reducers/requestStatus.js